__webpack_require__.p = "/GPC/_next/";